import { useEffect } from 'react'

import type { NextRouter } from 'next/router'

type BeforePopStateCallback = () => boolean

export default function useBeforePopState(
  router: NextRouter,
  cb: BeforePopStateCallback
) {
  useEffect(() => {
    router.beforePopState(cb)

    return () => {
      router.beforePopState(() => true)
    }
  }, [cb, router])
}
